import { render, staticRenderFns } from "./proPay.vue?vue&type=template&id=2147bd99&scoped=true"
import script from "./proPay.vue?vue&type=script&lang=js"
export * from "./proPay.vue?vue&type=script&lang=js"
import style0 from "./proPay.vue?vue&type=style&index=0&id=2147bd99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147bd99",
  null
  
)

export default component.exports